import { render, staticRenderFns } from "./PaymentButton.vue?vue&type=template&id=2e770055&"
import script from "./PaymentButton.vue?vue&type=script&lang=ts&"
export * from "./PaymentButton.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports